export const REFERRAL_PENDING_COOKIE_NAME = 'campus_pending_ref'

const REFERRAL_CODE_PATTERN = /^[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{8}$/

export const REFERRAL_COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60

export function normalizeReferralCode(raw?: string | null): string | null {
  if (!raw) return null
  const code = raw.trim().toUpperCase()
  return REFERRAL_CODE_PATTERN.test(code) ? code : null
}

export function isApplyPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '') || '/'
  return (
    normalized === '/admissions-application' ||
    normalized.endsWith('/admissions-application')
  )
}
